import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { ProductType } from '@/types';
import { log, warn } from '@/services/Log';

interface PLPWatchDogProps {
  products: ProductType[],
  baseHref: string,
  baseUrl: string,
}

const PLPWatchDog: (p: PLPWatchDogProps) => void = ({
  products,
  baseHref,
  baseUrl,
}) => {
  const router = useRouter()
  useEffect(() => {
    const pagDefaultFilters = baseUrl.split('?')[1].split('&').map(param=>param.split('=')[0])
    const defaultFiltersNames = [...pagDefaultFilters, 'sort']
    const filterIsNotDefault = (f:string) => !!f && !(defaultFiltersNames.includes(f))
    const filtersFromSearch = `${window.location.search}`.replace('?', '').split('&')
    const hasFiltersApplied = !!filtersFromSearch.filter(filterIsNotDefault).length
    if (hasFiltersApplied && !products.length) {
      const href = baseHref.replace(/(\?*)(\&*)$/,'')
      const url = baseUrl.replace(/(\?*)(\&*)$/,'')
      warn(`PLP Watchdog redirecting due to filters combination without products`)
      log(`router.push( "${href}", "${url}")`)
      router.push(href, url)
    }
  }, [products.length, baseHref, baseUrl])
}

export default PLPWatchDog
